module.exports = __webpack_public_path__ + "static/img/3.bf47a916.png";